import React from 'react';
import { Line } from 'react-chartjs-2';
const AreaChart = ({ chartData, options }: any) => {
  return <Line data={chartData} options={options} height={120} />;
};

export default AreaChart;
